export default class Disegno {
    constructor(arg = undefined) {
      if (arg != undefined) {
        const campi = this.setCampi();
        campi.forEach((c) => {
          this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
        });
      } else {
        const campi = this.setCampi();
        campi.forEach((c) => {
          this[c.nome] = c.default_val;
        });
      }
    }
  
    // Metodo per resettare tutti i campi
    reset() {
      const campi = this.setCampi();
  
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  
    setCampi() {
      const campi = [
        { nome: "data_ins", default_val: "" },
        { nome: "data_mod", default_val: "" },
        { nome: "des_disegno", default_val: "" },
        { nome: "des_utente", default_val: localStorage.nominativo },
        { nome: "id_disegno", default_val: -1 },
        { nome: "id_utente", default_val: localStorage.id_profilo },
        { nome: "nodi", default_val: [] },
        { nome: "validita", default_val: 1 },
      ];
  
      return campi;
    }
  }